import { useOrigin } from "@/features/flow/hooks/use-origin";
import { FromURL } from "@/features/flow/types";
import _ from "lodash";
import { twMerge } from "tailwind-merge";

type DotsNavigationProps = {
  total: number;
  current?: number;
} & React.ComponentPropsWithoutRef<"div">;

export default function DotsNavigation({ total, current, ...props }: DotsNavigationProps) {
  const origin = useOrigin();
  return (
    <>
      <div className={twMerge("flex space-x-3", props.className)} {..._.omit(props, "className")}>
        {Array.from({ length: total }, (_, index) => (
          <div
            key={index}
            className={twMerge(
              current !== undefined && index <= current
                ? origin !== FromURL.None
                  ? "bg-primary"
                  : "bg-blue-500"
                : origin !== FromURL.None
                  ? "bg-primary_light dark:bg-primary"
                  : "bg-blue-100 dark:bg-blue-800",
              "h-2 w-2 rounded-lg"
            )}
          ></div>
        ))}
      </div>
    </>
  );
}
